import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import banner from '../../assets/images/Privacy Banner.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const Privacy = () => {
  const { top } = useLocation();
  useEffect(()=>{
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  },[top])
  return (
    <>
    <div className="container-fluid gx-0">
        <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
    </div>
      <div className="container py-lg-5 py-3">

        <div className="row">
            {/* <h1 className='main-heading'>Privacy and Cookie Policy</h1> */}
            <div className="col-12">
                <div className="top-content" data-aos="zoom-in">
                    <p>At Oreus Lifesciences, we value your privacy and are committed to protecting your personal data. This policy outlines how we collect, use, and protect your information.
                    </p>
                </div>
            </div>
        </div>

        <div className="row py-lg-5 py-3">
          <div className="col-12">
            <h1 data-aos="zoom-in">Personal Data Collection</h1>
          </div>
          <div className="col-lg-6 col-md-6">
           <div data-aos="zoom-in">
           <h5>We collect personal data</h5>
            <ol>
              <li>When you visit our website</li>
              <li>When you contact us through email, phone, or contact forms</li>
              <li>When you register for our services or newsletters</li>
            </ol>
           </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h5 >Types of Data Collected</h5>
              <ol>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Operating system</li>
              </ol>
            </div>
          </div>
          
        </div>

        <div className="row py-lg-5 py-3">
         
          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
            <h1>Data Usage</h1>
              <h5>We use your data</h5>
              <ol>
                <li>To respond to your enquiries</li>
                <li>To provide requested services</li>
                <li>To improve our website and services</li>
                <li>To send newsletters and promotional materials (with consent)</li>
                <li>To comply with regulatory requirements</li>
              </ol>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h1>Data Protection</h1>
              <h5>We implement</h5>
              <ol>
                <li>Secure Sockets Layer (SSL) encryption</li>
                <li>Firewalls and access controls</li>
                <li>Regular security audits</li>
                <li>Data backup and disaster recovery procedures</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row py-lg-5 py-3 ">
          <div className="col-12 ">
            <h1 data-aos="zoom-in">Cookie Policy</h1>
          </div>

          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h5>Our website uses cookies to</h5>
              <ol>
                <li>Enhance user experience</li>
                <li>Track website usage</li>
                <li>Improve website performance</li>
               
              </ol>
            </div>
          </div>
          
          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h5>Types of Cookies </h5>
              <ol>
                <li>Session cookies (deleted after session)</li>
                <li>Persistent cookies (remain until expiration)</li>
                <li>Third-party cookies (e.g., Google Analytics)</li>
              </ol>
            </div>
          </div>


        </div>

        <div className="row py-lg-5 py-3">
          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h1 >Cookie Management</h1>
              <h5>You can</h5>
              <ol>
                <li>Accept or decline cookies</li>
                <li>Manage cookies through browser settings</li>
                <li>Opt-out of Google Analytics tracking</li>
              </ol>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h1>Data Sharing</h1>
              <h5>We do not share your data with third parties, except</h5>
              <ol>
                <li>With consent</li>
                <li>To comply with regulatory requirements</li>
                <li>To protect our rights and interests</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row py-lg-5 py-3">
        <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h1>Data Retention</h1>
              <h5>We retain data</h5>
              <ol>
                <li>For as long as necessary to provide services</li>
                <li>For compliance with regulatory requirements</li>
                <li>For a maximum of 30 days</li>
              </ol>
            </div>
          </div>

          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h1>Your Rights</h1>
              <h5>You have the right to</h5>
              <ol>
               <li>Access and rectify personal data</li>
               <li>Erase personal data</li>
               <li>Restrict data processing</li>
               <li>Object to data processing</li>
               <li>Lodge a complaint with regulatory authorities</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="row py-lg-5 py-5">
          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
              <h1>Changes to This Policy</h1>
              <p className='pe-lg-5'>We reserve the right to update this policy. Changes will be posted on this page.</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div data-aos="zoom-in">
            <h1>Contact Us</h1>
            <h5>For questions or concerns, please contact</h5>
              <p>OREUS LIFESCIENCES</p>
              <p>Email :oreuslife@gmail.com</p>
              <p>Phone Number : +91 97600 11544, +91 75000 82082</p>
              <p>Effective Date : 28/10/2024</p>
              <p>Version: 1.0</p>
              </div>
          </div>
        </div>

        
      </div>
    </>
  )
}

export default Privacy
